import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=06154678&scoped=true"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"
import style0 from "./TokenList.scss?vue&type=style&index=0&id=06154678&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06154678",
  null
  
)

export default component.exports